var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cil:building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.625 22.25V1.25H3.375V22.25H0.75V23.75H23.25V22.25H20.625ZM19.125 22.25H12.75V19.25H11.25V22.25H4.875V2.75H19.125V22.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.5 14.75H9V16.25H7.5V14.75ZM11.25 14.75H12.75V16.25H11.25V14.75ZM15 14.75H16.5V16.25H15V14.75ZM7.5 10.25H9V11.75H7.5V10.25ZM11.25 10.25H12.75V11.75H11.25V10.25ZM15 10.25H16.5V11.75H15V10.25ZM7.5 5.75H9V7.25H7.5V5.75ZM11.25 5.75H12.75V7.25H11.25V5.75ZM15 5.75H16.5V7.25H15V5.75Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany2);
export default __webpack_public_path__ + "static/media/company2.804019cdac6601d80b7ed78313377b4e.svg";
export { ForwardRef as ReactComponent };